<template>
  <div class="modal-overlay" v-if="showSubscribeModal" @click.self="close">
    <div class="modal-content">
      <button class="close-btn" @click="close">&times;</button>
      <div class="modal-header">
        <h2><span class="sports">SPORTS</span><span class="hub">HUB</span></h2>
      </div>
      <div class="modal-body">
            <h3 class="main-heading">Get Full Access!</h3>
            <p class="sub-heading">Unlock the ultimate sports experience</p>
            <ul class="benefits-list">
              <li>
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="10" cy="10" r="9" fill="#28A745" stroke="#28A745" stroke-width="2"/>
                  <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Full Access to All 4 Sport Zones</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="10" cy="10" r="9" fill="#28A745" stroke="#28A745" stroke-width="2"/>
                  <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>24/7 Ad-Free Sports TV</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="10" cy="10" r="9" fill="#28A745" stroke="#28A745" stroke-width="2"/>
                  <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Exclusive Live Updates & Fixtures</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="10" cy="10" r="9" fill="#28A745" stroke="#28A745" stroke-width="2"/>
                  <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Premium Prize Pools</span>
              </li>
            </ul>
            <button class="submit-btn" @click="handleSubscribe" :disabled="isRedirecting">
              {{ isRedirecting ? 'Redirecting...' : 'Subscribe for R10/day' }}
            </button>
            <p class="terms-text">By continuing you agree to the <a href="#" class="terms-link" @click.prevent>terms & conditions.</a></p>
            <p class="data-charges">Data charges may apply.</p>
        <p class="error text-center" v-if="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import modalMixin from '@/mixins/modalMixin'
import goToTpf from '@/functions/goToTpf'

export default {
  name: 'SubscribeModal',
  mixins: [modalMixin],
  data() {
    return { isRedirecting: false }
  },
  computed: {
    ...mapState(['showSubscribeModal', 'error'])
  },
  watch: {
    showSubscribeModal(show) {
      if (show) this.isRedirecting = false
    }
  },
  methods: {
    ...mapMutations(['closeAllModals', 'setError', 'setShowSubscribeModal']),

    handleSubscribe() {
      this.setError(null)
      this.isRedirecting = true

      if (!goToTpf()) {
        this.isRedirecting = false
        this.setError('Subscription is unavailable right now. Please try again later.')
        return
      }

      this.setShowSubscribeModal(false)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/modal-common';

.modal-header {
  margin-bottom: $space-base;

  h3 {
    display: none;
  }
}

.main-heading {
  font-size: 20px;
  font-weight: 800;
  color: $brand-dark;
  margin: 0 0 6px 0;
  text-align: center;
}

.sub-heading {
  font-size: 14px;
  color: $brand-dark;
  margin: 0 0 $space-base 0;
  text-align: center;
  font-weight: 400;
}

.benefits-list {
  list-style: none;
  padding: 0;
  margin: 0 0 $space-base 0;

  li {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: $space-md;
    font-size: 13px;
    color: $brand-dark;

    &:last-child {
      margin-bottom: 0;
    }
  }

  svg {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
  }
}

.submit-btn {
  margin-bottom: $space-md;
}

.terms-text {
  font-size: 11px;
  color: $gray-500;
  text-align: center;
  margin: 0 0 6px 0;
  line-height: 1.4;
}

.terms-link {
  color: $brand-dark;
  text-decoration: underline;
  cursor: pointer;
}

.data-charges {
  font-size: 11px;
  color: $gray-500;
  text-align: center;
  margin: 0 0 $space-sm 0;
}
</style>
